// Mertra-style product cards (custom): image gallery dots/arrows, size quick-add, "+" toggle.
// Everything is delegated from the document, so cards added later (load more, filters,
// section re-renders in the theme editor) work without re-binding.
(() => {
  const cardOf = (el) => el.closest('.mx-card');

  function syncDots(track) {
    const card = cardOf(track);
    const dots = card?.querySelectorAll('.mx-dot');
    if (!dots?.length) return;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }

  document.addEventListener(
    'scroll',
    (event) => {
      const track = event.target;
      if (track instanceof Element && track.matches('[data-mx-track]')) {
        requestAnimationFrame(() => syncDots(track));
      }
    },
    true
  );

  async function refreshCart() {
    const modal = document.querySelector('cart-modal');
    const cart = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`).then((r) => r.json());
    const bubble = document.getElementById('CartBubble');
    if (bubble) {
      bubble.textContent = cart.item_count || '';
      bubble.classList.toggle('hidden', !cart.item_count);
    }
    if (modal?.reloadContent) {
      await modal.reloadContent();
      modal.show?.();
    } else {
      window.location.href = `${window.Shopify?.routes?.root ?? '/'}cart`;
    }
  }

  async function addToCart(button) {
    button.classList.add('is-loading');
    try {
      const response = await fetch(window.routes?.cart_add_url ?? '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.mxAdd), quantity: 1 }] }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add to cart');

      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 1500);
      cardOf(button)?.classList.remove('is-open');
      await refreshCart();
    } catch (error) {
      // The "+" button is icon-only, so it just flashes instead of showing the message.
      if (button.classList.contains('mx-card__plus')) {
        button.classList.add('is-error');
        button.title = error.message;
        setTimeout(() => button.classList.remove('is-error'), 2000);
      } else {
        const original = button.textContent;
        button.textContent = error.message.length > 24 ? 'Unavailable' : error.message;
        setTimeout(() => (button.textContent = original), 2000);
      }
    } finally {
      button.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-mx-add]');
    if (add) {
      event.preventDefault();
      if (!add.disabled) addToCart(add);
      return;
    }

    const toggle = event.target.closest('[data-mx-toggle]');
    if (toggle) {
      event.preventDefault();
      const card = cardOf(toggle);
      const open = !card.classList.contains('is-open');
      document.querySelectorAll('.mx-card.is-open').forEach((c) => c.classList.remove('is-open'));
      card.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open);
      return;
    }

    const arrow = event.target.closest('[data-mx-prev], [data-mx-next]');
    if (arrow) {
      event.preventDefault();
      const track = cardOf(arrow).querySelector('[data-mx-track]');
      const step = arrow.hasAttribute('data-mx-next') ? 1 : -1;
      const max = track.scrollWidth - track.clientWidth;
      let left = track.scrollLeft + step * track.clientWidth;
      if (left > max + 2) left = 0;
      if (left < -2) left = max;
      track.scrollTo({ left });
      return;
    }

    if (!event.target.closest('.mx-card')) {
      document.querySelectorAll('.mx-card.is-open').forEach((c) => c.classList.remove('is-open'));
    }
  });
})();
